import styles from "./EditProfileProfessional.module.scss";

import { useEditProfileProfessional } from "./hooks/useEditProfileProfessional";
import ProfessionalInfoSection from '../EditProfessionalInfo/EditProfessionalInfo';
import { BookingPanel } from '../../ProfessionalDetail/BookingPanel';
import Loading from '../../ui/Loading/Loading';
import { UserStatusToast } from '../../ui/UserStatusToast/UserStatusToast';

const EditProfileProfessional = () => {
    const {
        t,
        user,
        loading,
        profileData,
        professions,
        availability,
        availabilityLoading,
        professionalUid,
        onSubmit
    } = useEditProfileProfessional();

    return (
        <div className={styles['professional-detail']}>
            <div className={styles['status-toast-wrapper']}>
                <UserStatusToast />
            </div>
            {loading || availabilityLoading ? <Loading fullscreen text={t('appAdmin.EditProfileProfessional.loading')} /> : null}
            <div className={styles['professional-detail__layout']}>
                <div className={styles['professional-detail__content']}>
                    {user && profileData && (
                        <ProfessionalInfoSection
                            user={{
                                profile: profileData
                            }}
                            professions={professions}
                            onSubmit={onSubmit}
                            allowInternalToggle
                        />
                    )}
                </div>
                <div className={styles['professional-detail__sidebar']}>
                    <BookingPanel
                        professionalUid={professionalUid ?? ""}
                        availability={availability ?? []}
                        setIsBookingModalOpen={() => { }}
                        modality={profileData?.details?.consult_type}
                        consultTime={profileData?.details?.consult_time}
                        consultPrice={profileData?.details?.consult_price}
                        currency={profileData?.details?.currency}
                        pricingMode={profileData?.details?.pricing_mode}
                        initialPrice={profileData?.details?.initial_price}
                        initialDuration={profileData?.details?.initial_duration}
                        followupPrice={profileData?.details?.followup_price}
                        followupDuration={profileData?.details?.followup_duration}
                        bookingMode={profileData?.details?.booking_mode}
                        requestSchedule={profileData?.details?.request_schedule}
                        messagingEnabled={['1', 1, 'true', true].includes(profileData?.details?.messaging_enabled ?? true)}
                        professionalName={`${profileData?.first_name || ''} ${profileData?.last_name || ''}`}
                        professionalPicture={profileData?.details?.image}
                        isOwnProfile={true}
                        isPassivePreview={true}
                    />
                </div>
            </div>
        </div>
    );
}

export default EditProfileProfessional;